module.exports = __webpack_public_path__ + "img/book-blue.e2552d16.svg";